/**
 * Dedicated /book page — separate from the homepage anchor /#contact so it
 * gets its own indexable URL with own title/description/canonical.
 * Reuses the Contact form component from the homepage.
 */
import { useEffect } from "react";
import { Link } from "react-router-dom";

import { Cursor, Header, Footer, Contact, StripeBand } from "@/pages/Site";
import { Seo } from "@/components/Seo";
import { seoFor } from "@/lib/seo-pages";

export default function BookPage() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const seo = seoFor("/book");

  return (
    <main className="relative isolate overflow-hidden bg-[#FDFDFD]">
      <Seo
        title={seo.title}
        description={seo.description}
        canonical={seo.canonical}
        image="https://peanutfactorystudio.com/og-image.jpg"
      />
      <Cursor />
      <div className="grain-overlay" aria-hidden />
      <Header />

      {/* Lightweight hero — stripe + breadcrumb + intro */}
      <section className="relative pt-28 md:pt-40 pb-10 md:pb-14" data-testid="book-hero">
        <div className="absolute left-0 right-0 top-20 md:top-24">
          <StripeBand height="h-[3px]" />
        </div>
        <div className="mx-auto max-w-[1400px] px-6 md:px-10">
          <nav className="flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-[#666] mb-6" aria-label="breadcrumb">
            <Link to="/" data-testid="breadcrumb-home" className="hover:text-[#FF5E00]">home</Link>
            <span>·</span>
            <span className="text-[#FF5E00]">book the studio</span>
          </nav>

          <div className="grid grid-cols-12 gap-6 md:gap-10 items-end">
            <div className="col-span-12 lg:col-span-8">
              <h1 className="font-display font-medium tracking-tighter text-[#1A1A1A] leading-[0.95] text-5xl md:text-6xl lg:text-7xl">
                book peanut factory
                <br />
                <span className="italic-serif text-[#FF5E00]">studio</span>.
              </h1>
            </div>
            <div className="col-span-12 lg:col-span-4">
              <p className="text-base md:text-lg leading-relaxed text-[#1A1A1A]/75">
                Check availability and book Peanut Factory Studio in Hackney
                Wick, East London. Full day, half day and hourly studio hire
                available Monday to Sunday. We respond to every enquiry the same
                day.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* The actual booking form (re-used from homepage) */}
      <Contact />

      <Footer />
    </main>
  );
}
